import EventImg from '@/assets/images/pricing/discount-img.svg';
import CountDownTimer from '@/components/CountDownTimer';
import PricingModal, { ModalType } from '.';
import { Description, Title } from './style';

interface PropsType {
  isOpen: boolean;
  onClose: () => void;
}

export default function DiscountEventModal({
  isOpen = true,
  onClose,
}: PropsType) {
  return (
    <PricingModal
      isOpen={isOpen}
      onClose={onClose}
      header={
        <>
          <img src={EventImg} alt="discount-event" />
          <CountDownTimer />
          <Title>x2 Credits for Our First 100 Subscribers!</Title>
          <Description>
            {`Enter the code`} <b>EARLY100</b>{' '}
            {`upon checkout process, and we'll
          double your credits to give you even more possibilities.`}
          </Description>
        </>
      }
      type={ModalType.DISCOUNT_EVENT}
    />
  );
}
